import { useEffect, useState } from "react";
import SwipeableViews from "react-swipeable-views";
import { Row } from "reactstrap";
import AndroidAddToHomeScreen1 from "../../../Assets/AndroidAddToHomeScreen1.jpg";
import AndroidAddToHomeScreen2 from "../../../Assets/AndroidAddToHomeScreen2.jpg";
import AndroidAddToHomeScreen3 from "../../../Assets/AndroidAddToHomeScreen3.jpg";
import SafariAddToHomeScreen1 from "../../../Assets/SafariAddToHomeScreen1.jpg";
import SafariAddToHomeScreen2 from "../../../Assets/SafariAddToHomeScreen2.jpg";
import SafariAddToHomeScreen3 from "../../../Assets/SafariAddToHomeScreen3.jpg";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Button } from "@mui/material";

enum Steps {
    Step1,
    Step2,
    Step3
}

interface Props {
    isAndroidSection: boolean;
}

const AddToHomeScreenImages = (props: Props) => {
    const [selectedStep, setSelectedStep] = useState<Steps>(Steps.Step1);
    const [images, setImages] = useState<any[]>();

    useEffect(() => {
        if (props.isAndroidSection) {
            setImages([
                AndroidAddToHomeScreen1, 
                AndroidAddToHomeScreen2, 
                AndroidAddToHomeScreen3
            ]);
        } else {
            setImages([
                SafariAddToHomeScreen1, 
                SafariAddToHomeScreen2, 
                SafariAddToHomeScreen3
            ]);
        }
    }, [props.isAndroidSection]);

    if (!images)
        return null;

    return (
        <div style={{position: "relative", width: "100%"}} className="">
            <SwipeableViews
                axis={"x"}
                index={selectedStep}
                onChangeIndex={(index: number) => setSelectedStep(index)}
            >
                <div className="pt-2">
                    <Row
                        className="m-0 ps-1 pe-1 justify-content-center"
                    >
                        <img
                            style={{width: "35vh", height: "73vh", borderRadius: "10"}} 
                            src={images[0]} alt="Stap 1 afbeelding" 
                        />
                    </Row>
                </div>
                <div className="pt-2">
                    <Row
                        className="m-0 ps-1 pe-1 justify-content-center"
                    >
                        <img 
                            style={{width: "35vh", height: "73vh"}} 
                            src={images[1]} alt="Stap 2 afbeelding" 
                        />                
                    </Row>
                </div>
                <div className="pt-2 ">
                    <Row
                        className="m-0 ps-1 pe-1 justify-content-center"
                    >
                        <img 
                            style={{width: "35vh", height: "73vh"}} 
                            src={images[2]} alt="Stap 3 afbeelding" 
                        />
                    </Row>
                </div>
            </SwipeableViews>

            {selectedStep > 0 && 
                <span style={{position: "absolute", left: 0, top: "35vh"}}>
                    <Button 
                        className="justify-content-start"
                        variant="text" 
                        color="inherit" 
                        onClick={() => setSelectedStep(index => index > 0 ? index - 1 : 0)}
                    >
                        <ArrowBackIcon color="action" fontSize="medium" />
                    </Button>
                </span>
            }
            {selectedStep < 2 &&
                <span style={{position: "absolute", right: 0, top: "35vh"}}>
                    <Button 
                        className="justify-content-end"
                        variant="text" 
                        color="inherit" 
                        onClick={() => setSelectedStep(index => index < 2 ? index + 1 : 2)}
                    >
                        <ArrowForwardIcon color="action" fontSize="medium" />
                    </Button>
                </span>
            }
        </div>
    );
}

export default AddToHomeScreenImages;